/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-max-props-per-line */
import {Card} from 'primereact/card';
import {withTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import {useEffect, useState} from 'react';
import {Chart} from 'primereact/chart';

export const DashboardCardChartComponent = ({title, initialChartData, dataSetLabel, backgroundColor}) => {
    const [chartData, setChartData] = useState({});
    const [chartOptions, setChartOptions] = useState({});
    useEffect(() => {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');
        const labels = [];
        const datas = [];
        Object.entries(initialChartData).forEach(([key, value]) => {
            labels.push(key);
            datas.push(value);
        });
        const data = {
            labels: [
                labels[0],
                labels[1],
                labels[2],
                labels[3],
                labels[4],
                labels[5],
                labels[6],
                labels[7],
                labels[8],
                labels[9],
                labels[10],
                labels[11],
            ],
            datasets: [
                {
                    label: dataSetLabel,
                    // label: 'Kilometry',
                    // backgroundColor: "#1e325c",
                    backgroundColor: backgroundColor,
                    borderColor: documentStyle.getPropertyValue('--blue-500'),
                    data: [
                        datas[0],
                        datas[1],
                        datas[2],
                        datas[3],
                        datas[4],
                        datas[5],
                        datas[6],
                        datas[7],
                        datas[8],
                        datas[9],
                        datas[10],
                        datas[11],
                    ],
                },
            ],
        };
        const options = {
            maintainAspectRatio: false,
            aspectRatio: 1,
            responsive: true,
            plugins: {
                legend: {
                    labels: {
                        fontColor: textColor,
                    },
                    //position: 'top',
                },
            },
            scales: {
                x: {
                    ticks: {
                        color: textColorSecondary,
                        font: {
                            weight: 500,
                        },
                    },
                    grid: {
                        display: false,
                        drawBorder: false,
                    },
                },
                y: {
                    ticks: {
                        color: textColorSecondary,
                    },
                    grid: {
                        color: surfaceBorder,
                        drawBorder: false,
                    },
                },
            },
        };

        setChartData(data);
        setChartOptions(options);
    }, [initialChartData, dataSetLabel, backgroundColor]);

    return (
        <Card className='dashboard-card-chart mt-4' title={<div className='title'>{title}</div>}>
            <div style={{ width: '100%', height: '280px' }}>
                <Chart type='bar' data={chartData} options={chartOptions} />
            </div>
        </Card>
    );
};

DashboardCardChartComponent.defaultProps = {};

DashboardCardChartComponent.propTypes = {
    imageHref: PropTypes.string,
    title: PropTypes.string,
    dataSetLabel: PropTypes.string,
    backgroundColor: PropTypes.string,
};

export default withTranslation()(DashboardCardChartComponent);
